module.exports = __webpack_public_path__ + "img/joinyg.272f1053.png";